<template>
  <el-dialog :title="title" :visible.sync="open" :center="true" width="80%" @close="cancel" :close-on-click-modal="false">

    <span style="margin-left:10px">该入库单中存在以下产品的入库价格与平台价格不一致：</span>
    <!-- ，对应的明细已标为红色底色 -->
    <el-table ref="childTable" border :data="details" style="width: auto; margin: 10px 10px 0" stripe :header-cell-style="{ background: '#DDEBFF' }">
      <!-- <el-table-column type="index" width="50"> </el-table-column> -->
      <el-table-column prop="supplierProductNo" label="供应商产品编码" min-width="180"></el-table-column>
      <el-table-column show-overflow-tooltip prop="productName" label="产品名称" min-width="150"></el-table-column>
      <el-table-column show-overflow-tooltip prop="specName" label="规格型号" min-width="120"></el-table-column>
      <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" min-width="150"></el-table-column>
      <el-table-column prop="batch" show-overflow-tooltip label="批次号" min-width="120"></el-table-column>
      <el-table-column prop="serialNo" show-overflow-tooltip label="序列号" min-width="120"></el-table-column>
      <el-table-column show-overflow-tooltip prop="productCode" label="商品代码" min-width="100" />
      <el-table-column show-overflow-tooltip prop="newProductId" label="产品ID" min-width="100" />
      <el-table-column show-overflow-tooltip prop="newPrice" label="入库价格" min-width="150">
        <template slot-scope="scope">
          <span v-if="!editMode">{{scope.row.newPrice}}</span>
          <el-input v-else v-model="scope.row.newPrice"></el-input>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="priceMonitorPrice" label="平台采购价" min-width="100" />
      <!-- <el-table-column show-overflow-tooltip prop="priceMonitorMixPrice" label="平台最低价" min-width="100" /> -->
    </el-table>
    <div slot="footer" class="dialog-footer" style="text-align:center">
      <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
      <el-button v-if="!editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="update">修 改</el-button>
      <el-button v-if="!editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="submit">不修改直接提交</el-button>
      <el-button v-else class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确认修改并提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  UpdateProductPrice
} from '@/api'

export default {

  mixins: [],
  components: {
  },
  /** 定义属性 */
  data () {
    return {
      open: false,
      title: '提示',
      editMode: false
    };
  },
  props: {
    id: {
      type: Number,
      default () {
        return 0;
      },
    },
    type: {
      type: Number,
      default () {
        return 0;
      },
    },
    details: {
      type: Array,
      default () {
        return [];
      },
    },
    show: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {
    show (val, oldVal) {
      this.open = val;
    },
  },
  /** 方法集合 */
  methods: {
    cancel () {
      this.editMode = false
      this.open = false;
      this.$emit("close");
    },
    update () {
      this.editMode = true
    },
    submit () {
      UpdateProductPrice({ id: this.id, type: this.type, productPriceDiffDetails: this.details })
        .then(res => {
          // this.$my_message(`修改成功`, 'success')
          this.editMode = false
          this.open = false;
          this.$emit("submit");
        })
    }
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () { },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped>
</style>
